import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ContattoVO } from "@app/shared/vo/contattoVO";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "contact-list",
  templateUrl: "contact-list.component.html",
})
export class ContactListComponent {
  @Input() values: ContattoVO[];

  @Output()
  updateLista: EventEmitter<ContattoVO[]> = new EventEmitter<ContattoVO[]>();

  @Output()
  updateSposta: EventEmitter<ContattoVO[]> = new EventEmitter<ContattoVO[]>();

  aggiorna(value: any) {
    console.log("contact-list aggiorna dopo remove: ", value);
    this.updateLista.emit(
      this.values.filter((item) => this.isContatto(item, value))
    );
  }

  sposta(value: any) {
    console.log(
      "contact-list aggiorna dopo sposta: ",
      this.values.filter((item) => item.idSoggetto + item.idRecapito === value)
    );
    this.updateSposta.emit(
      this.values.filter((item) => item.idSoggetto + item.idRecapito === value)
    );
  }

  aggiungi(value: any) {
    console.log("contact-list aggiorna dopo add: ", value);
    this.updateLista.emit(
      this.values.filter((item) => this.isContatto(item, value))
    );
  }

  private isContatto(item: any, value: any): boolean {
    console.log("isContatto", item.idSoggetto + item.idRecapito);
    return item.idSoggetto + item.idRecapito !== value;
  }
}
